// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"3b49316b","264":"a3406360","708":"74836c7b"}[chunkId] + ".chunk.css";
};